import { createSelector } from '@reduxjs/toolkit';
import type { IMethodology, ISector } from '__generated__';
import type { RootState } from 'store';
import { sectorApi } from 'services/sector/api';
import { methodologyApi } from './api';

export type IMethodologyWithSector = IMethodology & {
  sector: ISector | null;
};

export const selectActiveSectorsQueryResult = (state: RootState) =>
  sectorApi.endpoints.getActiveSectors.select()(state);

export const selectActiveSectors = createSelector(
  [selectActiveSectorsQueryResult],
  (result) => (Array.isArray(result.data) ? result.data : []),
);

export const selectSectorsById = createSelector([selectActiveSectors], (sectors) => {
  const map = new Map<number, ISector>();

  sectors.forEach((sector) => {
    if (sector.id != null) {
      map.set(sector.id, sector);
    }
  });

  return map;
});

export const selectActiveMethodologiesQueryResult = (state: RootState) =>
  methodologyApi.endpoints.getActiveMethodologies.select()(state);

export const selectActiveMethodologies = createSelector(
  [selectActiveMethodologiesQueryResult],
  (result) => (Array.isArray(result.data) ? result.data : []),
);

export const selectMethodologiesWithSector = createSelector(
  [selectActiveMethodologies, selectSectorsById],
  (methodologies, sectorsById): IMethodologyWithSector[] =>
    methodologies.map((methodology) => ({
      ...methodology,
      sector:
        methodology.sectorID != null ? (sectorsById.get(methodology.sectorID) ?? null) : null,
    })),
);
